<main class="flex justify-center items-center h-screen text-start">
    <div class="md:w-[35rem] w-[25rem] border-[1.5px] border-gray-200 rounded-lg p-7">
        <h2 class="text-base font-semibold text-[#4B4B4B]">
          <span [routerLink]="['/login']" class="text-[#8A8AA3] text-base me-2 cursor-pointer">
            <i [routerLink]="['/']" class="bi text-[#8A8AA3] text-base cursor-pointer" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i>
            {{ 'auth.back' | translate }}
          </span>
          {{ 'auth.reset_password.title' | translate }}
        </h2>
        <p class="text-[0.87rem] text-[#4B4B4B] mt-5">
            {{ 'auth.reset_password.description' | translate }}
        </p>

        <form class="mt-4" [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="generic-input-group">
                <label for="email" class="text-sm">
                    {{ 'auth.fields.email' | translate }}<span class="text-red-500">*</span>
                </label>
                <input type="email" name="email" formControlName="email" id="email" dir="ltr" class="text-left">

            </div>

            <button class="generic-submit-button flex justify-center items-center gap-2" [disabled]="loading" type="submit">
              <span *ngIf="loading" class="w-3 h-3 border border-t-0 border-white rounded-full animate-spin"></span>
              {{ 'auth.reset_password.submit' | translate }}
            </button>
        </form>
    </div>
</main>
